import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.423 4.736a2.914 2.914 0 1 0-5.81.457 2.914 2.914 0 0 0 5.81-.457ZM18.694 6.361a2.003 2.003 0 1 0-3.994.314 2.003 2.003 0 0 0 3.994-.314ZM5.88 14.006a1.604 1.604 0 1 0-3.198.251 1.604 1.604 0 0 0 3.197-.251ZM10.624 19.67a2.477 2.477 0 1 0 4.938-.388 2.477 2.477 0 0 0-4.938.388ZM19.597 12.357a1.603 1.603 0 1 0 .251 3.196 1.603 1.603 0 0 0-.251-3.196Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.423 4.736a2.914 2.914 0 1 0-5.81.457 2.914 2.914 0 0 0 5.81-.457ZM18.694 6.361a2.003 2.003 0 1 0-3.994.314 2.003 2.003 0 0 0 3.994-.314ZM5.88 14.006a1.604 1.604 0 1 0-3.198.251 1.604 1.604 0 0 0 3.197-.251ZM10.624 19.67a2.477 2.477 0 1 0 4.938-.388 2.477 2.477 0 0 0-4.938.388ZM19.597 12.357a1.603 1.603 0 1 0 .251 3.196 1.603 1.603 0 0 0-.251-3.196ZM6.524 5l6.515 14.706",
  stroke: "currentColor",
  "stroke-width": "1.5"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "m4.244 14.214 2.233-9.261M13.064 19.57l6.617-5.581-2.979-7.429",
  stroke: "currentColor"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }